export enum ChartType {
    BarChart = 'BarChart',
    LineChart = 'LineChart',
    GeoChart = 'GeoChart',
    ColumnChart = 'ColumnChart',
    PieChart = 'PieChart'
}